import {Select, TableSearchInput} from '@/components';

import {PRODUCTION_STATUS_DISPLAY} from './productionStatus';
import type {ProcessorListProps, ProductionStatusFilter} from './types';

export type ProcessorFiltersProps = Pick<
  ProcessorListProps,
  | 'searchTerm'
  | 'handleSearch'
  | 'statusFilter'
  | 'handleStatusFilter'
  | 'statusCounts'
>;

const STATUS_OPTIONS: {value: ProductionStatusFilter; label: string}[] = [
  {value: 'ALL', label: 'All'},
  {value: 'LIVE', label: PRODUCTION_STATUS_DISPLAY.LIVE.label},
  {value: 'PARTLY_LIVE', label: PRODUCTION_STATUS_DISPLAY.PARTLY_LIVE.label},
  {value: 'NOT_LIVE_YET', label: PRODUCTION_STATUS_DISPLAY.NOT_LIVE_YET.label},
  {value: 'RETIRED', label: PRODUCTION_STATUS_DISPLAY.RETIRED.label},
  {value: 'UNKNOWN', label: 'Unknown'},
];

const ProcessorFilters: React.FC<ProcessorFiltersProps> = ({
  searchTerm,
  handleSearch,
  statusFilter,
  handleStatusFilter,
  statusCounts,
}) => (
  <div className="mt-5 w-full flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
    <TableSearchInput
      value={searchTerm}
      onChange={handleSearch}
      placeholder="Search by name or code"
    />
    <Select
      className="sm:w-56"
      label="Production"
      value={statusFilter}
      options={STATUS_OPTIONS.map(({value, label}) => ({
        key: `${label} (${statusCounts[value]})`,
        value,
      }))}
      onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
        handleStatusFilter(e.target.value as ProductionStatusFilter)
      }
    />
  </div>
);

export default ProcessorFilters;
